/**
 * The collection model for resource at the LSCloud /API/Locale REST endpoint
 */

import Locale from 'app/src/data/models/Locale';
import RetailCollection from 'app/src/data/models/RetailCollection';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class LocaleCollection extends RetailCollection {
  get model() {
    return Locale;
  }

  /**
   * Return the REST url for collection of Options
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getURL('/Locale.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.Locale is an array of the Locale structures we want.
    // Return it directly if an object is found; otherwise return an empty array and let
    // Backbone handle it
    return response.Locale || [];
  }
}
